module.exports = __webpack_public_path__ + "media/images/career_camp/2023/user_3-5fa0817c7eb1e30728a6c362ae278864.png";